import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";

import type { OtpFormSubmitPayload } from "@src/components/OtpForm/Otp.types";
import type { ResendOtpFormSubmitPayload } from "@src/components/ResendOtpForm/ResendOtp.types";

import type { ResetPasswordFormSubmitPayload, SigninFormSubmitPayload, SubmitForgotPinFormPayload } from "./Login.types";


interface LoginState {
  resetPasswordEnabled: boolean;
  recaptchaV2SiteKey?: string;
}

const initialState: LoginState = {
  resetPasswordEnabled: true
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    requestNewPin(state, action: PayloadAction<ResendOtpFormSubmitPayload>) {
      return state;
    },
    setResetPasswordEnabled(state, action: PayloadAction<boolean>) {
      state.resetPasswordEnabled =  action.payload;
    },
    setRecaptchaV2SiteKey(state, action: PayloadAction<string>) {
      state.recaptchaV2SiteKey = action.payload;
    },
    submitForgotPinForm(state, action: PayloadAction<SubmitForgotPinFormPayload>) {
      return state;
    },
    submitSigninForm(state, action: PayloadAction<SigninFormSubmitPayload>) {
      return state;
    },
    submitLoginOtpForm(state, action: PayloadAction<OtpFormSubmitPayload>) {
      return state;
    },
    resendLoginOtp(state, action: PayloadAction<ResendOtpFormSubmitPayload>) {
      return state;
    },
    submitResetPasswordForm(state, action: PayloadAction<ResetPasswordFormSubmitPayload>) {
      return state;
    },
    destroy() {
      return {
        ...initialState
      };
    }
  }
});


export default loginSlice.reducer;
export const {
  requestNewPin,
  setRecaptchaV2SiteKey,
  submitForgotPinForm,
  destroy
} = loginSlice.actions;
export const loginActions = loginSlice.actions;
